import KeyMirror from 'keymirror';

const PostType = KeyMirror({
	GET_LIST_POST: null,
	GET_LIST_POST_PAGING: null,
	CREATE_POST: null,
	UPDATE_POST: null,
	HIDE_POST: null,
	DELETE_POST: null,
});

export default PostType;
